import { render, staticRenderFns } from "./AppTextarea.vue?vue&type=template&id=750f72b5&scoped=true"
import script from "./AppTextarea.vue?vue&type=script&lang=js"
export * from "./AppTextarea.vue?vue&type=script&lang=js"
import style0 from "./AppTextarea.vue?vue&type=style&index=0&id=750f72b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750f72b5",
  null
  
)

export default component.exports